import type { TClientInsuranceStatus } from 'api/swagger';

export const INSURANCE_STATUSES_REQUIRING_ATTENTION: TClientInsuranceStatus[] = [
  'expired',
  'expiring_soon',
  'expiring_soon_gap_before_next',
];
